import { RouteEnum } from 'App';

export const notApproveCommentText =
  'The person in the profile does not match the person in the exam session.';

export const headerLinks = [
  // ? for tests, since this const in global scope
  { path: RouteEnum.Partners, title: 'Partners' },
  { path: RouteEnum.AuditQueue, title: 'Audit Queue' },
  { path: RouteEnum.NeedsReview, title: 'Needs Review' },
  { path: RouteEnum.IncompleteAudits, title: 'Incomplete Audits' },
];

// todo: should be fixed on the stream-service side
export const WRONG_VIDEO_LENGTH_VALUE = 31000;

export const CONTACT_PROCTORFREE_SUCCESS_TEAM_BASE_URL =
  'https://www.proctorfree.com/-bd688033-4965-43c1-92fe-fd622c746c86';
export const CONTACT_PROCTORFREE_SUPPORT_AUDIT_BASE_URL =
  'https://www.proctorfree.com/thank-you-fd0f86e9-2984-4270-aa78-557da6d9bdb9';
